import { Component, ReactNode, cloneElement } from 'react';
import { useNavigate } from 'react-router';
import { AdminApi } from '../admin-api';
import PageLoading from './PageLoading';

export default function ProtectedRoute(props: any): ReactNode {
  return <ProtectedRouteComp navigate={useNavigate()} {...props} />;
}

class ProtectedRouteComp extends Component {
  constructor(readonly props: Readonly<{ children: any; navigate?: any }>) {
    super(props);

    this.state = {
      isOk: true,
      isLoading: true,
      currentUser: null,
    };
  }

  state: Readonly<{
    isOk: boolean;
    isLoading: boolean;
    currentUser: any;
  }>;

  async componentDidMount(): Promise<void> {
    const _data = await AdminApi.get('/session');

    if (_data) {
      this.setState({ isOk: true, isLoading: false, currentUser: _data });
    } else {
      this.props.navigate('/login', { replace: true });
    }
  }

  render(): ReactNode {
    if (this.state.isLoading) {
      return <PageLoading></PageLoading>;
    } else if (this.state.isOk) {
      return cloneElement(this.props.children, {
        currentUser: this.state.currentUser,
      });
    } else {
      return <div>Redirecionando...</div>;
    }
  }
}
